import AppInstance from "./GlobalAxios";

const CollectionService = {
  getAllCollections: async () => {
    try {
      const response = await AppInstance.get('/collections');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCollectionById: async (id) => {
    try {
      const response = await AppInstance.get(`/collections/id/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createCollection: async (data) => {
    try {
      const response = await AppInstance.post('/collections', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCollection: async (id, data) => {
    try {
      const response = await AppInstance.put(`/collections/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteCollection: async (id) => {
    try {
      const response = await AppInstance.delete(`/collections/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Get brands for dropdown in collection form
  getAllBrands: async () => {
    try {
      // Try the new API endpoint first
      try {
        const response = await AppInstance.get('/brand/getAll');
        return response.data;
      } catch (err) {
        // If the new endpoint fails, try the alternative endpoint
        const response = await AppInstance.get('/brand');
        return response.data;
      }
    } catch (error) {
      // Return empty array to prevent UI errors
      return { statusCode: 200, data: [] };
    }
  },
  
  // Get brand by ID for resolving brand references
  getBrandById: async (id) => {
    try {
      // Based on backend code analysis, /brand/get/:id returns an array, not an object
      const response = await AppInstance.get(`/brand/get/${id}`);
      
      // Check if we got a valid response with data
      if (response && response.data) {
        // The API returns an array, so we need to get the first item
        if (Array.isArray(response.data) && response.data.length > 0) {
          return { 
            statusCode: 200, 
            data: response.data[0] 
          };
        }
        
        // If response.data is already formatted with statusCode
        if (response.data.statusCode && response.data.data) {
          return response.data;
        }
        
        // If response.data is a single object
        if (typeof response.data === 'object' && !Array.isArray(response.data)) {
          return { 
            statusCode: 200, 
            data: response.data 
          };
        }
      }
      
      // If no valid data was found, return default
      return { 
        statusCode: 200, 
        data: { name: `Brand ${id.substring(0, 8)}...`, _id: id, brand_name: `Brand ${id.substring(0, 8)}...` } 
      };
    } catch (error) {
      // Try an alternative approach - get by name (assuming id might be a slug or name)
      try {
        // Some brand IDs might be names or slugs
        const response = await AppInstance.get(`/brand/${id}`);
        if (response && response.data) {
          if (response.data.statusCode && response.data.data) {
            return response.data;
          }
          return { 
            statusCode: 200, 
            data: response.data 
          };
        }
      } catch (secondError) {
        // Silently handle the error
      }
      
      // Return a default object instead of throwing to avoid breaking the UI
      return { 
        statusCode: 200, 
        data: { name: `Brand ${id.substring(0, 8)}...`, _id: id, brand_name: `Brand ${id.substring(0, 8)}...` } 
      };
    }
  }
};

export default CollectionService;
